<script setup lang="ts">
import { computed, nextTick, ref, watch } from 'vue'
import CloseIcon from '@/svg/close-o.svg'
import NoticeIcon from '@/assets/imgs/notice.png'
import { useBroadcastStore } from '@/stores/broadcast'

const broadcastStore = useBroadcastStore()

const contentRef = ref<HTMLElement | null>(null)

const visible = computed({
  get: () => broadcastStore.visible,
  set: (value) => {
    if (!value) broadcastStore.close()
  },
})

const current = computed(() => broadcastStore.current)

watch(
  () => broadcastStore.currentIndex,
  async () => {
    await nextTick()
    contentRef.value?.scrollTo({ top: 0 })
  },
)
</script>

<template>
  <van-popup
    v-model:show="visible"
    position="center"
    :close-on-click-overlay="false"
    :style="{ width: '290px' }"
    class="overflow-visible bg-transparent!"
    teleport="body"
  >
    <div v-if="current" class="relative flex flex-col items-center">
      <img
        v-if="current.banner"
        :src="current.banner"
        :alt="current.title"
        class="block w-full h-auto rounded-t-2xl object-cover"
      />

      <div
        class="w-full px-4 pt-4 pb-5 bg-white box-border"
        :class="current.banner ? 'rounded-2xl -mt-5' : 'rounded-2xl'"
      >
        <div class="flex items-center gap-1.5 mb-3">
          <img :src="NoticeIcon" class="size-6 shrink-0" alt="" />
          <h3 class="m-0 text-base font-semibold text-text-primary">{{ current.title }}</h3>
        </div>

        <div
          ref="contentRef"
          class="max-h-[148px] min-h-30 overflow-y-auto text-sm leading-relaxed text-text-secondary wrap-break-word [-webkit-overflow-scrolling:touch]"
          v-html="current.content"
        />

        <div v-if="broadcastStore.hasMultiple" class="flex items-center justify-between gap-2 mt-4">
          <van-button
            plain
            size="small"
            class="flex-1 h-9 bg-white! disabled:border-text-third disabled:text-text-third!"
            type="primary"
            :disabled="broadcastStore.isFirst"
            @click="broadcastStore.goPrev"
          >
            &lt; 上一条
          </van-button>
          <span class="shrink-0 min-w-9 text-center text-sm text-[#646566]">
            {{ broadcastStore.pageLabel }}
          </span>
          <van-button
            plain
            type="primary"
            size="small"
            class="flex-1 h-9 bg-white! disabled:border-text-third disabled:text-text-third!"
            :disabled="broadcastStore.isLast"
            @click="broadcastStore.goNext"
          >
            下一条 &gt;
          </van-button>
        </div>

        <van-button
          type="primary"
          block
          class="mt-3! h-11 rounded-lg"
          @click="broadcastStore.handleConfirm"
        >
          我知道了
        </van-button>
      </div>

      <button
        type="button"
        class="flex items-center justify-center mt-5 p-0 cursor-pointer"
        aria-label="关闭"
        @click="broadcastStore.close"
      >
        <CloseIcon class="size-8 text-white" />
      </button>
    </div>
  </van-popup>
</template>
